module.exports = __webpack_public_path__ + "static/media/bg-opening551367e325abea31c8cbffdd93ca3bc5.webp";